import * as React from 'react';

var Spacer = function () { return (React.createElement("div", { className: "spacer" })); };

export { Spacer as default };
//# sourceMappingURL=Spacer.js.map
